<template>
  <div class="inline-block">
    <slot v-bind="{ openModal }"/>

    <modal
      :show="showModal"
      @close="closeModal"
      @reset.prevent="closeModal"
    >
      <template #title>
        Select schools to compare
      </template>

      <template #body>
        <compare-schools-form :model-value="modelValue"/>
      </template>
    </modal>
  </div>
</template>

<script setup>
import CompareSchoolsForm from "@/components/forms/CompareSchoolsForm.vue"
import Modal from "@/components/modals/Modal.vue"
import { ref } from "vue"

defineOptions({
  inheritAttrs: false,
})

defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
})

const showModal = ref(false)
const selectedSchool = ref(null)

const openModal = () => {
  selectedSchool.value = null
  showModal.value = true
}

const closeModal = () => {
  showModal.value = false
}
</script>
